import { Typography, Container } from "@mui/material";
import useIsMobileView from "../../utils/hooks/useIsMobileView";

const IntroductionSlide = () => {
  const IsMobileView = useIsMobileView();
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Typography paragraph variant={IsMobileView ? "h4" : "h2"} align="center" sx={styles.title}>
        DÜSARTILISE KÕNE
      </Typography>
      <Typography paragraph variant={IsMobileView ? "h4" : "h2"} align="center" sx={styles.title}>
        ARUSAADAVUSE TEST
      </Typography>
    </Container>
  );
};

export default IntroductionSlide;

const styles = {
  rootContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    userSelect: "none",
  },
  title: {
    height: "fit-content",
  },
};
